import Vue from 'vue'
import Vuex from 'vuex'

import Auth from '../warehouse/Auth';
import Dashboard from '../warehouse/Dashboard';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    Auth,
    Dashboard
  }
});